// PROTOTYPE
import { Button, Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from '../../lexical-editor.module.css';
import type { ToolbarVideoController } from './types';

const { Text } = Typography;

interface VideoEmbedTabProps {
  video: ToolbarVideoController;
}

export function VideoEmbedTab({ video }: VideoEmbedTabProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.videoTabBody}>
      <Text type="secondary">{t('exp_video_embed_help')}</Text>
      <div className={styles.imageUrlRow}>
        <Input
          ref={video.inputRef}
          aria-label={t('exp_video_embed_url_aria')}
          data-testid="videoEmbedUrlInput"
          onChange={(event) => {
            video.setEmbedUrlValue(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              video.submitEmbed();
            }
          }}
          placeholder={t('exp_video_embed_placeholder')}
          value={video.embedUrlValue}
        />
        <Button
          data-testid="videoEmbedSubmitButton"
          disabled={video.embedUrlValue.trim() === ''}
          onClick={video.submitEmbed}
          type="primary"
        >
          {t('exp_video_embed_submit')}
        </Button>
      </div>
      {video.embedError === 'invalid' && (
        <div className={styles.imageUploadError} data-testid="videoEmbedError">
          {t('exp_video_embed_error_invalid')}
        </div>
      )}
    </div>
  );
}
